const lessonData = {

  2: {
    checkpoint: false,
    last: false,
    checkpoints: [],
    images: [
      {image: 'https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/gettyimages-886134986-640x640.jpg', alt: 'Police and parademics respond to a call', order: 0}
    ],
    layoutNumber: 4,
    navigation: [
      { available_scene: "4", current_scene: "2", previous_scene: "1",text: "Continue" },
    ],
    scene_number: "2",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [``],
    text: [
      `<p>A case study is a story that is used to generate discussion and critical thinking.</p><p>Case studies are realistic. Some are based on true stories, while others are made up, but written in such a way that they could have really happened.</p`
    ],
    title: `What is a case study?`,
    videos: [],
    audio: [],
  },
  
  4: {
    checkpoint: false,
    last: false,
    checkpoints: [], 
    images: [
      {image: 'https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/pexels-edgard-5628406.jpg', alt: 'You noticed you were waking up feeling awful.', order: 0}
    ],
    layoutNumber: 4,
    navigation: [
      { available_scene: "5", current_scene: "4", previous_scene: "2",text: "Continue" },
    ],
    scene_number: "4",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>Usually, case studies contain complicated situations, where difficult decisions must be made.</p><p>They are very effective tools for practicing applying knowledge to a real-life scenario. Just like real life, there aren’t always clear “right” or “wrong” answers in a case study.</p><p>The complexity of the situation is intentionally thought-provoking, allowing learners to bring their unique perspectives to the situation.</p>`,
    ],
    title: null,
    videos: [],
    audio: [],
  },
  5: {
    checkpoint: false,
    last: false,
    checkpoints: [], 
    images: [
      {image: 'https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/Screenshot+2025-02-14+at+2.40.47%E2%80%AFPM.png', alt: 'A decision point example', order: 0}
    ],
    layoutNumber: 1,
    navigation: [
      { available_scene: "8", current_scene: "5", previous_scene: "4",text: "Continue" },
    ],
    scene_number: "5",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>The interactive case studies that we offer integrate reflection and decision points throughout, which remove the need to pause for a long discussion.</p><p>Learners are provided information they need to understand the context for the story, then are asked to begin making choices from the point of view of one of the characters.</p><p>They are given multiple choice and open-ended question prompts to help guide them through the decision-making and reflection process.</p>`,
    ],
    title: null,
    videos: [],
    audio: [],
  },
  
  8: {
    checkpoint: false,
    last: false,
    checkpoints: [],
    images: [],
    layoutNumber: 4,
    navigation: [
      { available_scene: "10", current_scene: "8", previous_scene: "5",text: "Continue" },
    ],
    scene_number: "8",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [`<p>These case studies are built to be completed individually, but they could be used in a group setting, too.</p><p>For example, a group of learners could go through the case study together and make choices as a team; or they could go through the case study on their own and come together as a group to discuss the choices they made.</p>
      <p>Group case study discussions can be used in a number of settings to promote new ways of thinking, including: </p><ul>
      <li>During team professional development meetings</li><li>During onboarding training for new hires</li><li>To bring together cross-functional team members to solve a problem</li><li>To give team members exposure to a problem that they weren’t previously aware of</li><li>To analyze past situations so that teams can develop better strategies for the future</li><li>To learn about best practices from other fields, industries, or contexts</li></ul>`],
    title: null,
    videos: [],
    audio: [],
  },
 
  10: {
    checkpoint: false,
    last: true,
    checkpoints: [],
    images: [],
    layoutNumber: 6,
    navigation: [{available_scene: "10", current_scene: "10", previous_scene: "11",text: "End Lesson" }],
    scene_number: "10",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>You now know a little bit more about how to use case studies for learning! Explore the case studies we have available on the <a href="https://chaplaincyinnovation.org/training-credentials/case-studies" rel="_blank" ref="noopener noreferrer">Chaplaincy Innovation Lab</a> website to dig in!</p>`
    ],
    title: null,
    videos: [],
    audio: [],
  },
};

export default lessonData;